import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Text = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

export const ContainerError = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 100px;
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
`;
